<template>

    <a-yoga-layout
        width-auto="1" height-auto="1"
        flex-direction="row"
        geometry="primitive: plane;" material="visible: false"
    >
        <a-image
            :src="block.field_values.image.url"
            :width="imageWidth"
            :height="imageHeight"
            yoga-layout-item="margin: 0.05; marginEdge: right; padding: 0"
        ></a-image>

        <a-html autoEnable="false">
          <div class="vr">
            <h1>
              {{ block.field_values.text }}
            </h1>
            <div v-html="block.field_values.html"></div>
          </div>
        </a-html>
      
<!--        <a-entity-->
<!--            html="ppu: 1000; autoWidth: true; autoHeight: true"-->
<!--            geometry="primitive: plane; width:0; height: 0" material="visible: false; transparent: true"-->
<!--            yoga-layout-item="margin: 0.05; marginEdge: left; padding: 0"-->
<!--        >-->
<!--            <div class="vr vr-distance-1-5 vr-width-1-5 vr-height-auto xvr-padding">-->
<!--                <h2>-->
<!--                    {{ block.field_values.text }}-->
<!--                </h2>-->
<!--                <div v-html="block.field_values.html"></div>-->
<!--            </div>-->
<!--        </a-entity>-->

<!--        <a-yoga-layout-->
<!--            width-auto="1" height-auto="1"-->
<!--            padding="0"-->
<!--            flex-direction="column"-->
<!--            align-items="center"-->
<!--            justify-content="space-between"-->
<!--            yoga-layout-item=""-->

<!--            geometry="primitive: plane;" material="visible: false"-->
<!--        >-->

<!--            <a-entity-->
<!--                html="ppu: 1000; autoWidth: true; autoHeight: true"-->
<!--                geometry="primitive: plane; width:0; height: 0" material="visible: false; transparent: true"-->
<!--                yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"-->
<!--            >-->
<!--                <div class="vr vr-distance-1-5 vr-width-1-0 vr-height-auto vr-padding">-->
<!--                    <h2>-->
<!--                        {{ block.field_values.text }}-->
<!--                    </h2>-->
<!--                    <div v-html="block.field_values.html"></div>-->
<!--                </div>-->
<!--            </a-entity>-->
<!--        </a-yoga-layout>-->
    </a-yoga-layout>

<!--    <a-entity>-->
<!--        <a-image src="/aframe-assets/images/siemens-icon.png" width="0.12" height="0.1"></a-image>-->
<!--        <a-image :src="block.field_values.image.url" width="0.2" height="0.2"></a-image>-->
<!--    </a-entity>-->

<!--    <a-yoga-layout-->
<!--        width-auto="1" height-auto="1"-->
<!--        padding="0"-->
<!--        flex-wrap="nowrap"-->
<!--        flex-direction="row"-->
<!--        align-items="flex-start"-->
<!--        justify-content="flex-start"-->
<!--        yoga-layout-item="margin: 0.02; marginEdge: top"-->

<!--        geometry="primitive: plane;" material="visible: false"-->
<!--    >-->
<!--        <a-image src="/aframe-assets/images/siemens-icon.png" width="0.01" height="0.01"></a-image>-->
<!--        <a-image :src="lock.field_values.image.url" width="0.05" height="0.05"></a-image>-->


<!--    </a-yoga-layout>-->
<!--&lt;!&ndash;        &ndash;&gt;-->
<!--    <a-entity-->
<!--        html="ppu: 1000; autoWidth: true; autoHeight: true"-->
<!--        geometry="primitive: plane; width:0; height: 0" material="visible: false; transparent: true"-->
<!--        yoga-layout-item="margin: 0.01; marginEdge: left; padding: 0"-->
<!--    >-->
<!--        <div class="vr vr-distance-1-5 vr-width-1-5 vr-height-auto vr-padding">-->
<!--            <h2>-->
<!--                {{ block.field_values.text }}-->
<!--            </h2>-->
<!--            <div v-html="block.field_values.html"></div>-->
<!--            <img :src="block.field_values.image.url" alt="Image">-->
<!--            <p>-->
<!--                URL: {{ block.field_values.image.url }}-->
<!--            </p>-->

<!--            <p>-->
<!--                Image:-->
<!--                <img src="/uploads/images/d3690b1be518067aa50c06ac7a2993b1.png">-->
<!--            </p>-->

<!--        </div>-->
<!--    </a-entity>-->
</template>

<script>
export default {
    name: "ImageText",
    props: ['block'],
    computed: {
        imageWidth() {
            return 1;
        },
        imageHeight() {
            return this.block.field_values.image.height * this.imageWidth / this.block.field_values.image.width;
        },
    },
}
</script>

<style scoped>

</style>